"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Dropdown_1 = __importStar(require("components/design-system/dropdown/Dropdown"));
const FloatingComponent_1 = __importDefault(require("components/objectives/compact-objective/fragments/FloatingComponent"));
const ConditionalWrapper_1 = __importDefault(require("components/shared/ConditionalWrapper"));
const ShareLink = ({ dataCy, getToken, pathName, onSuccessFunction, trigger, withFloatingComponent = true }) => {
    return (react_1.default.createElement(Dropdown_1.default, null,
        react_1.default.createElement(Dropdown_1.default.Trigger, { dataCy: dataCy }, trigger),
        react_1.default.createElement(Options, { pathName: pathName, getToken: getToken, onSuccessFunction: onSuccessFunction, withFloatingComponent: withFloatingComponent })));
};
const Options = ({ pathName, getToken, onSuccessFunction, withFloatingComponent, isDirectOptions = false }) => {
    const { open } = (0, Dropdown_1.useDropdown)() || {};
    const shareLinkHandler = (type) => __awaiter(void 0, void 0, void 0, function* () {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data } = (yield getToken());
        if (data) {
            switch (type) {
                case 'email':
                    window.open(`mailto:?subject=&body=https://${location.host}/${pathName}?token=${data === null || data === void 0 ? void 0 : data.token}`);
                    break;
                case 'whatsapp':
                    window.open(`https://wa.me/?text=https://${location.host}/${pathName}?token=${data === null || data === void 0 ? void 0 : data.token}`);
                    break;
                case 'telegram':
                    window.open(`https://telegram.me/share/url?url=https://${location.host}/${pathName}?token=${data === null || data === void 0 ? void 0 : data.token}`);
                    break;
                case 'line':
                    window.open(`https://line.me/R/msg/text/?https://${location.host}/${pathName}?token=${data === null || data === void 0 ? void 0 : data.token}`);
                    break;
                case 'copy-link': {
                    const result = (0, HelperUtils_1.copyToClipboard)(`https://${location.host}/${pathName}?token=${data === null || data === void 0 ? void 0 : data.token}`);
                    if (result) {
                        onSuccessFunction && onSuccessFunction();
                    }
                    break;
                }
            }
        }
    });
    const options = [
        {
            text: (0, HelperUtils_1.getCultureLocale)('Email'),
            onClick: () => shareLinkHandler('email'),
            iconName: 'icon-email',
            dataCy: 'share-email'
        },
        {
            text: (0, HelperUtils_1.getCultureLocale)('Whatsapp'),
            onClick: () => shareLinkHandler('whatsapp'),
            iconName: 'icon-whatsapp',
            dataCy: 'share-whatsapp'
        },
        {
            text: (0, HelperUtils_1.getCultureLocale)('Telegram'),
            onClick: () => shareLinkHandler('telegram'),
            iconName: 'icon-telegram',
            dataCy: 'share-telegram'
        },
        {
            text: (0, HelperUtils_1.getCultureLocale)('Line'),
            onClick: () => shareLinkHandler('line'),
            iconName: 'icon-line',
            dataCy: 'share-line'
        },
        {
            text: (0, HelperUtils_1.getCultureLocale)('Copy Link'),
            onClick: () => shareLinkHandler('copy-link'),
            iconName: 'icon-link',
            dataCy: 'share-link'
        }
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null, open && (react_1.default.createElement(ConditionalWrapper_1.default, { condition: withFloatingComponent, wrapper: (children) => (react_1.default.createElement(FloatingComponent_1.default, null, children)) },
        react_1.default.createElement(Dropdown_1.default.MenuItems, Object.assign({ options: options, customClass: "w-[160px] top-[-2px]", vPosition: "relative", type: "absolute" }, (isDirectOptions
            ? {
                style: {
                    transform: 'translateX(-100%)'
                }
            }
            : [])))))));
};
ShareLink.Options = Options;
exports.default = ShareLink;
